import React, { useEffect, useRef, useState } from 'react';
import { Form, Overlay } from 'react-bootstrap';
import { PLUS_ICON } from '../../assets/image';
import BackIcon from 'assets/img/backIconArrow.svg';
import './lableManager.css';
import { useSocket } from '../../context/SocketContext';
import boardToast from '../../utils/boardToast';
import { TOAST_TYPE } from 'utils/AppToast';
import ConfirmModal from 'components/ConfirmModal';
import { createProjectBoardSocket, labelColors } from 'utils/Helpers';
import { useAuth } from 'contexts/AuthContext';

const LabelManager = ({
  projectBoardId = '',
  defaultLabels = [],
  milestone = [],
  defaultOpen,
  setClose,
  showLabels = true,
  setLabelsBottom,
  makeSetCloseChanges,
  isMasterCalender,
  showSubTask,
  viewMode
}) => {
  const socket = useSocket();
  const { user } = useAuth();
  const labelToggleRef = useRef(null);
  const [labels, setLabels] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedLabels, setSelectedLabels] = useState([]);
  const [openDropdown, setOpenDropdown] = useState(defaultOpen);
  const [view, setView] = useState('list');
  const [newLabel, setNewLabel] = useState({ title: '', color: '#2ecc71' });
  const [editingLabel, setEditingLabel] = useState(null);
  const [isFirstRender, setFirstRender] = useState(true);
  const [showConfirm, setShowConfirm] = useState(false);
  const [isDeleting, setDeleting] = useState(false);

  useEffect(() => {
    // console.log(milestone.labelIds, 'milestonemilestone');

    if (milestone && Array.isArray(milestone.labelIds)) {
      // normalize to array of strings (IDs only)
      const normalized = milestone.labelIds.map((l) => (typeof l === 'string' ? l : l._id));
      setSelectedLabels(normalized);
      if (normalized.length == 0) {
        setClose(true);
      } else {
        setLabelsBottom(true);
      }
    } else {
      setClose(true);
    }
  }, [milestone, defaultLabels]);

  useEffect(() => {
    setLabels((prev) => {
      const updated = defaultLabels.map((l, index) => ({
        id: l._id || index,
        title: l.name,
        color: l.color || '#2ecc71',
        textColor: l.textColor
      }));

      // Keep local labels that don’t exist in new defaultLabels
      const extra = prev.filter((pl) => !updated.some((ul) => ul.id === pl.id));

      return [...updated, ...extra];
    });
  }, [defaultLabels]);

  const handleToggleLabel = (id) => {
    let masterSocket = socket;
    let selectedBoardId = projectBoardId;
    if (isMasterCalender) {
      masterSocket = createProjectBoardSocket(user._id, milestone?.projectBoardId);
      selectedBoardId = milestone?.projectBoardId;
    }
    setSelectedLabels((prev) => {
      const updated = prev.includes(id) ? prev.filter((l) => l !== id) : [...prev, id];
      console.log(updated);
      if (showSubTask) {
        masterSocket.emit('update-subtask', {
          projectBoardId: selectedBoardId,
          milestoneId: milestone.milestoneId,
          id: milestone._id, // current toggled label
          payload: { labelIds: updated }
        });
      } else {
        // 🔹 Emit socket event
        masterSocket.emit('update-milestone', {
          projectBoardId: selectedBoardId,
          id: milestone._id, // current toggled label
          payload: { labelIds: updated }
        });
      }

      return updated;
    });
  };

  const handleSaveLabel = () => {
    let masterSocket = socket;
    let selectedBoardId = projectBoardId;
    if (isMasterCalender) {
      masterSocket = createProjectBoardSocket(user._id, milestone?.projectBoardId);
      selectedBoardId = milestone?.projectBoardId;
    }
    if (!newLabel.title.trim()) {
      boardToast('Label name is required', TOAST_TYPE.ERROR);
      return;
    }
    if (!newLabel.color || newLabel.color === 'transparent') {
      boardToast('Please select a color', TOAST_TYPE.ERROR);
      return;
    }
    if (editingLabel) {
      // update existing label (local only for now)
      setLabels(labels.map((l) => (l.id === editingLabel.id ? { ...editingLabel, ...newLabel } : l)));
      // 🔹 Emit socket for new label
      let payload = {
        name: newLabel.title,
        color: newLabel.color,
        textColor: newLabel.textColor
      };
      masterSocket.emit('update-label', {
        projectBoardId: selectedBoardId,
        id: editingLabel.id, // current toggled label
        payload: payload
      });
      setEditingLabel(null);
    } else {
      // create new label locally
      const created = { id: Date.now(), ...newLabel };
      // setLabels([...labels, created]);

      // 🔹 Emit socket for new label
      masterSocket.emit('create-label', {
        name: newLabel.title,
        color: newLabel.color,
        textColor: newLabel.textColor,
        projectBoardId: selectedBoardId
      });
    }

    setNewLabel({ title: '', color: '#21835A', textColor: '#FFFFFF' });
    setView('list');
  };

  const handleEdit = (label) => {
    setEditingLabel(label);
    setNewLabel(label);
    setView('create');
  };

  const handleDeleteLabel = () => {
    let masterSocket = socket;
    let selectedBoardId = projectBoardId;
    if (isMasterCalender) {
      masterSocket = createProjectBoardSocket(user._id, milestone?.projectBoardId);
      selectedBoardId = milestone?.projectBoardId;
    }
    // 🔥 Emit socket delete-label
    masterSocket.emit('delete-label', {
      id: editingLabel.id,
      projectBoardId
    });
    setShowConfirm(false);
    boardToast(`Label deleted successfully.`, TOAST_TYPE.SUCCESS);
    // Optimistic local update
    setLabels((prev) => prev.filter((l) => l.id !== editingLabel.id));
    setSelectedLabels((prev) => prev.filter((sid) => sid !== editingLabel.id));

    // Cleanup state
    setEditingLabel(null);
    setNewLabel({ title: '', color: '#2ecc71' });
    setView('list');
  };

  const deleteConfirmContent = (
    <>
      <h2 className="mb-3">Are you sure?</h2>
      <h3>You want to Delete this label?</h3>
    </>
  );
  return (
    <div className="custom-lable-maneger">
      <div className="labels-container">
        {showLabels &&
          labels
            .filter((l) => selectedLabels.includes(l.id))
            // .slice(0, 5)
            .map((label) => (
              <span
                key={label.id}
                className="label-text"
                style={{
                  backgroundColor: label.color,
                  color: label.textColor || '#fff'
                }}>
                {label.title}
              </span>
            ))}
        {/* {selectedLabels.length > 5 && <span className="plus_text">+{selectedLabels.length - 5}</span>} */}

        {/* Labels Dropdown */}
        <div className="dropdown">
          {/* <Dropdown.Toggle variant="light" id="dropdown-basic"> */}
          <button
            ref={labelToggleRef}
            type="button"
            className="btn btn-light icon-btn-round"
            onClick={() => {
              if (!viewMode) {
                setOpenDropdown(!openDropdown);
                setView('list');
                if (!openDropdown == false) {
                  if (makeSetCloseChanges) {
                    setClose(false);
                  }
                  setLabelsBottom(false);
                }
              }
            }}>
            <img src={PLUS_ICON} alt="plus-icon" />
          </button>
          {/* </Dropdown.Toggle> */}

          <Overlay
            target={labelToggleRef.current}
            show={openDropdown}
            placement="bottom-start"
            rootClose
            onHide={() => setOpenDropdown(false)}
            popperConfig={{
              strategy: 'fixed',
              modifiers: [
                {
                  name: 'flip',
                  options: { fallbackPlacements: ['top-start', 'bottom-end', 'top-end'] }
                },
                {
                  name: 'preventOverflow',
                  options: { boundary: 'viewport', padding: 12 }
                }
              ]
            }}>
            {({ placement, arrowProps, show: overlayShow, popper, hasDoneInitialMeasure, ...overlayProps }) => (
              <div {...overlayProps} className="custom-lable-maneger label-manager-overlay">
                <div className="dropdown-menu show label-manager-menu" style={{ minWidth: '298px' }}>
            {/* Header with back/close buttons */}
            <div className="d-flex justify-content-between align-items-center mb-2 header-lable">
              {view === 'create' ? (
                <>
                  <img
                    src={BackIcon}
                    className="cursor_pointer"
                    alt="plus-icon"
                    onClick={() => {
                      setEditingLabel(null);
                      setView('list');
                    }}
                  />{' '}
                  <button className="btn btn-sm btn-link btn-link-header">
                    {editingLabel ? 'Update' : 'Create'} Label
                  </button>
                </>
              ) : (
                <span>Labels</span>
              )}
              <button className="btn btn-sm btn-link closs-btn" onClick={() => setOpenDropdown(false)}>
                ✕
              </button>
            </div>

            {/* Label List View */}
            {view === 'list' && (
              <>
                <Form.Control
                  type="text"
                  placeholder="Search labels..."
                  className="mb-3 search-input"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
                <div className="select-label">Select Labels</div>
                <div className="scrolling-labels">
                  {labels
                    .filter((label) => label.title.toLowerCase().includes(searchTerm.toLowerCase().trim()))
                    .map((label) => (
                      <div
                        key={label.id}
                        className="d-flex justify-content-between align-items-center select-label-cover">
                        <div className="checkbox_cover">
                          <input type="checkbox" checked={selectedLabels.includes(label.id)} readOnly />
                          <span className="chk_box" onClick={() => handleToggleLabel(label.id)}></span>
                          <span
                            style={{
                              backgroundColor: label.color,
                              padding: '2px 6px',
                              borderRadius: '5px',
                              color: label?.textColor,
                              marginLeft: '5px',
                              fontSize: '16px',
                              fontFamily: 'Roboto',
                              width: '100%'
                            }}>
                            {label.title}
                          </span>
                        </div>
                        <span className="edit-icon cursor_pointer" onClick={() => handleEdit(label)}>
                          {' '}
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="18"
                            height="19"
                            viewBox="0 0 18 19"
                            fill="none">
                            {' '}
                            <path
                              d="M2.15703 14.087C2.19149 13.7768 2.20872 13.6218 2.25564 13.4768C2.29726 13.3483 2.35607 13.2259 2.43048 13.1131C2.51434 12.9859 2.62466 12.8756 2.8453 12.6549L12.75 2.75023C13.5784 1.9218 14.9216 1.9218 15.75 2.75023C16.5784 3.57865 16.5784 4.9218 15.75 5.75023L5.84529 15.6549C5.62466 15.8756 5.51434 15.9859 5.38717 16.0698C5.27434 16.1442 5.15197 16.203 5.02338 16.2446C4.87845 16.2915 4.72339 16.3087 4.41328 16.3432L1.875 16.6252L2.15703 14.087Z"
                              stroke="black"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />{' '}
                          </svg>{' '}
                        </span>
                      </div>
                    ))}
                </div>
                <button
                  className="btn btn-dark w-100 mt-2"
                  onClick={() => {
                    setEditingLabel(null);
                    setNewLabel({ title: '', color: '#4BCD97' });
                    setView('create');
                  }}>
                  Create new label
                </button>
              </>
            )}

            {/* Create/Edit View */}
            {view === 'create' && (
              <>
                <div className="create-label-btn">
                  <span style={{ backgroundColor: newLabel.color, color: newLabel.textColor }}>
                    {newLabel.title ? newLabel.title : ' '}{' '}
                  </span>
                </div>
                <span className="mb-1 d-block title2">Title</span>
                <Form.Control
                  className="mb-3 search-input"
                  type="text"
                  placeholder="Type label title"
                  value={newLabel.title}
                  onChange={(e) => setNewLabel({ ...newLabel, title: e.target.value })}
                />
                <div className="select-label">Select Labels</div>
                <div className="d-flex flex-wrap mb-2 select-box-cover">
                  {labelColors.map((label) => (
                    <div
                      key={label.color}
                      onClick={() => setNewLabel({ ...newLabel, color: label.color, textColor: label.textColor })}
                      style={{
                        width: '45px',
                        height: '31px',
                        borderRadius: '4px',
                        margin: '3px',
                        cursor: 'pointer',
                        backgroundColor: label.color,
                        border: newLabel.color === label.color ? '2px solid black' : '1px solid #ddd'
                      }}
                    />
                  ))}
                </div>

                {/* 🔹 Remove color option */}
                <div
                  className="select-label text-center cursor_pointer"
                  onClick={() => setNewLabel({ ...newLabel, color: 'transparent' })}>
                  Remove color
                </div>
                <div className="btn-grop-labels">
                  {editingLabel && (
                    <button
                      className="btn btn-danger w-50"
                      onClick={() => {
                        setShowConfirm(true);
                      }}>
                      Delete
                    </button>
                  )}
                  <button className={`btn btn-dark ${editingLabel ? 'w-50' : 'w-100'}`} onClick={handleSaveLabel}>
                    {editingLabel ? 'Update' : 'Create'}
                  </button>
                </div>
              </>
            )}
                </div>
              </div>
            )}
          </Overlay>
        </div>
      </div>
      <ConfirmModal
        show={showConfirm}
        onHide={() => {
          setShowConfirm(false);
        }}
        confirmationText={deleteConfirmContent}
        handleAction={handleDeleteLabel}
        closeText="Yes"
        loading={isDeleting}
        bgClassname={'whitebgmodal'}
      />
    </div>
  );
};

export default LabelManager;
